import { useState, useCallback, useMemo } from "react";
function useSizeDetector() {
  const [width, setWidth] = useState(null);
  const [height, setHeight] = useState(null);
  const ref = useCallback((element) => {
    if (!element) {
      return;
    }
    const boundingClientRect = element.getBoundingClientRect();
    setWidth(boundingClientRect.width);
    setHeight(boundingClientRect.height);
  }, []);
  return useMemo(() => ({
    ref,
    width,
    height
  }), [ref, width, height]);
}
export {
  useSizeDetector as default
};
